// make all anchor tags external
export default function transfromLinks(el: HTMLElement) {
  // let's make this IE compatible by using Array.from instead of calling foreach directly on nodelist
  Array.from(el.querySelectorAll('a')).forEach(l => l.setAttribute('target', '_blank'));
}
